const linearProgress = {
  root: {
    borderRadius: 16,
  },
  bar: {
    borderRadius: 16,
  },
  colorPrimary: {
    backgroundColor: '#ededed',
  },
};

export default linearProgress;
